module.exports = __webpack_public_path__ + "img/delete_Image_af.76897a36.svg";